<template>
  <div class="aboutsevices cards">
    <div class="container">
      <Title :msg="title.title"></Title>
      <div class="row m-auto">
        <onlycard class="inin col-12 "
        v-for="(item, index) in cards" :key="index" :card="item"></onlycard> <!-- col-md-6 -->
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title_nobg.vue';
import onlycard from '@/components/quartercard_one.vue';

export default {
  props: {
    quarterTitle: {
      title: '這是第一個title',
    },
    quarterWords: {
      type: Array,
      default: () => ([
        {
          who: '提供服務',
          things: ['第一點Lorem ipsum dolor.', '第二點Lorem ipsum dolor.', '第三點Lorem ipsum dolor.'],
          button: '請按1',
          buttonUrl: '/services_page1',
        },
        {
          who: '提供服務',
          things: ['第一點Lorem ipsum dolor.', '第二點Lorem ipsum dolor.', '第三點Lorem ipsum dolor.', '第四點Lorem ipsum dolor.'],
          button: '請按2',
          buttonUrl: '/services_page2',
        },
        {
          who: '提供服務',
          things: ['第一點Lorem ipsum dolor.', '第二點Lorem ipsum dolor.', '第三點Lorem ipsum dolor.'],
          button: '請按3',
          buttonUrl: '/services_page3',
        },
        {
          who: '提供服務',
          things: ['第一點Lorem ipsum dolor.', '第二點Lorem ipsum dolor.', '第三點Lorem ipsum dolor.', '第四點Lorem ipsum dolor.', '第五點Lorem ipsum dolor.'],
          button: '請按4',
          buttonUrl: '/services_page4',
        },
      ]),
    },
  },
  data() {
    return {
      title: this.quarterTitle,
      cards: this.quarterWords,
    };
  },
  components: {
    Title,
    onlycard,
  },
};
</script>

<style scoped lang="scss">
.aboutsevices {
  padding: 50px 20px;
  background-color: #ebebeb;
  .row{
    padding: 15px;
  }
}
@media screen and (max-width: 600px){
  .aboutsevices {
    padding: 50px 0;
    .row{
      padding: 0;
    }
  }
}
</style>
